import { MessageCircle } from "lucide-react";
import { WHATSAPP_NUMBER } from "@/config";
import { useLanguage } from "@/i18n/LanguageContext";

export const WhatsAppFloat = () => {
  const { t } = useLanguage();
  const text = encodeURIComponent(`Namaste ${t.brandFull}! I want to enquire about your services.`);
  return (
    <a
      data-testid="whatsapp-floating-button"
      href={`https://wa.me/${WHATSAPP_NUMBER}?text=${text}`}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-6 right-6 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-emerald-500 text-white shadow-xl transition-transform hover:scale-110"
    >
      <MessageCircle className="h-7 w-7" />
    </a>
  );
};
